import { styled, type SxProps, type Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';

import CustomButton from 'components/shared/CustomButton';

type ConfigurationSortModalStyles = {
  dialog: SxProps<Theme>;
  rootOptions: SxProps<Theme>;
  targetRowTop: (theme: Theme) => SystemStyleObject<Theme>;
  targetRowBottom: (theme: Theme) => SystemStyleObject<Theme>;
  listItem: SystemStyleObject<Theme>;
  listItemButton: (theme: Theme) => SystemStyleObject<Theme>;
  headerColumn: SystemStyleObject<Theme>;
};

export const styles: ConfigurationSortModalStyles = {
  dialog: (theme) => ({
    '& .MuiDialog-scrollPaper': {
      alignItems: 'center',
    },
    '& .MuiDialog-paperScrollBody': {
      verticalAlign: 'top',
    },
    '& .MuiDialog-paper': {
      borderRadius: '10px',
      color: theme.palette.primary.dark,
      maxWidth: '50%',
      overflow: 'hidden',
      background: theme.palette.gray[400],
    },
  }),
  rootOptions: (theme: Theme) => ({
    height: 'calc(100vh - 228px)',
    overflow: 'auto',
    marginBottom: '24px',
    backgroundColor: theme.palette.common.white,
  }),
  targetRowTop: (theme) => ({
    borderTop: `2px solid ${theme.palette.primary.main}`,
  }),
  targetRowBottom: (theme) => ({
    borderBottom: `2px solid ${theme.palette.primary.main}`,
  }),
  listItem: {
    padding: '4px 16px',
    textAlign: 'left',
  },
  listItemButton: (theme) => ({
    width: '100%',
    textAlign: 'left',
    color: theme.palette.common.black,
  }),
  headerColumn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '8px 16px',
  },
};

export const StyledButton = styled(CustomButton)({
  '&.MuiButton-contained': {
    minWidth: '105px',
    borderRadius: '4px',
  },
});
